import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ProjectsApiService } from 'src/services/projectsApi'

export const useGetProjectsQuery = () =>
  useQuery({
    queryFn: () => ProjectsApiService.getList(),
    queryKey: [QueryKey.GET_PROJECTS],
  })
